import { Injectable } from '@angular/core';
import { CookiesHelper } from '@shared/utils/cookies-helper';
import { GlobalConfigService } from '@shared/utils/global-config.service';
import { GlobalConstants } from '@shared/utils/global-constants';
import { AES, enc as CryptoEnc } from 'crypto-js';

@Injectable({
	providedIn: 'root'
})
export class EncryptionService {
	// eslint-disable-next-line @typescript-eslint/no-empty-function
	constructor() {}

	public getSessionStorage(key: string): any {
		const encKey = this.currentKey;
		if (sessionStorage.getItem(btoa(key)) && encKey) {
			const bytes = AES.decrypt(
				sessionStorage.getItem(btoa(key)) || '',
				this.currentKey
			);
			return bytes.toString(CryptoEnc.Utf8);
		} else {
			return null;
		}
	}

	public setSessionStorage(key: string, value: string) {
		const encryptedValues = AES.encrypt(value, this.currentKey);
		sessionStorage.setItem(btoa(key), encryptedValues.toString());
	}

	get currentKey(): string {
		if (CookiesHelper.get(this.currentCookieName)) {
			return atob(CookiesHelper.get(this.currentCookieName) || '');
		} else {
			return '';
		}
	}

	get currentCookieName() {
		return GlobalConstants.LOCAL_SBB_KEY_COOKIE + GlobalConfigService.sessionId;
	}
}
